import { useEffect, useRef } from 'react';

export default function useStorageChange(item: string, action: VoidFunction) {
  const savedAction = useRef<VoidFunction>();

  // Update ref.current value if action changes.
  // This allows our effect below to always get latest action
  // without us needing to pass it in effect deps array
  // and potentially cause effect to re-run every render.
  useEffect(() => {
    savedAction.current = action;
  }, [action]);

  useEffect(() => {
    const eventListener = (e: StorageEvent) => {
      if (e.key === item) {
        savedAction.current?.();
      }
    };

    window.addEventListener('storage', eventListener);

    return () => window.removeEventListener('storage', eventListener);
  }, [item]);
}
